import '../Styles/MarketStructureWidget.css';
import useMarketStructureAnalysisStore from '../Stores/marketStructureAnalysisStore';

function getValue(...values) {
  return values.find(value => value !== undefined && value !== null && value !== '');
}

function normalizeAnalysis(analysis) {
  if (!analysis) {
    return {
      marketStructureReview: '',
      currentStateInterpretation: '',
      traderTakeaway: '',
      summaryText: '',
      generatedAt: null,
    };
  }

  const sections = analysis.sections || {};

  return {
    marketStructureReview: getValue(
      analysis.marketStructureReview,
      analysis.market_structure_review,
      sections.marketStructureReview,
      sections.market_structure_review,
      analysis.review
    ),

    currentStateInterpretation: getValue(
      analysis.currentStateInterpretation,
      analysis.current_state_interpretation,
      sections.currentStateInterpretation,
      sections.current_state_interpretation,
      analysis.currentState,
      analysis.current_state
    ),

    traderTakeaway: getValue(
      analysis.traderTakeaway,
      analysis.trader_takeaway,
      sections.traderTakeaway,
      sections.trader_takeaway,
      analysis.takeaway
    ),

    summaryText: getValue(
      analysis.summary,
      analysis.analysis,
      analysis.analysis_text,
      analysis.text
    ),

    generatedAt: getValue(
      analysis.generatedAt,
      analysis.generated_at,
      analysis.createdAt,
      analysis.created_at
    ),
  };
}

function splitSummaryText(summaryText) {
  if (!summaryText) {
    return {
      marketStructureReview: '',
      currentStateInterpretation: '',
      traderTakeaway: '',
    };
  }

  const marketStructureMatch = summaryText.match(
    /Market Structure Review([\s\S]*?)(Current State Interpretation|Trader Takeaway|$)/i
  );

  const currentStateMatch = summaryText.match(
    /Current State Interpretation([\s\S]*?)(Trader Takeaway|$)/i
  );

  const traderTakeawayMatch = summaryText.match(
    /Trader Takeaway([\s\S]*)/i
  );

  return {
    marketStructureReview: marketStructureMatch?.[1]?.trim() || summaryText,
    currentStateInterpretation: currentStateMatch?.[1]?.trim() || '',
    traderTakeaway: traderTakeawayMatch?.[1]?.trim() || '',
  };
}

function TextBlock({ children }) {
  if (!children) return null;

  return <p className="marketStructureText">{children}</p>;
}

export default function MarketStructureWidget() {
  const analysis = useMarketStructureAnalysisStore(state => state.analysis);
  const isLoading = useMarketStructureAnalysisStore(state => state.isLoading);
  const error = useMarketStructureAnalysisStore(state => state.error);

  const normalized = normalizeAnalysis(analysis);
  const splitSections = splitSummaryText(normalized.summaryText);

  const marketStructureReview =
    normalized.marketStructureReview || splitSections.marketStructureReview;

  const currentStateInterpretation =
    normalized.currentStateInterpretation || splitSections.currentStateInterpretation;

  const traderTakeaway =
    normalized.traderTakeaway || splitSections.traderTakeaway;

  return (
    <div className="panel monitorCard marketStructureCard">
      <div className="panelHeader compactPanelHeader marketStructureHeader">
        <div>
          <h2>Market Structure</h2>
          {/*<p>AI-generated SPX Gamma structure review</p>*/}
        </div>
      </div>

      {isLoading && !analysis && (
        <div className="marketStructureState">
          <span className="marketStructurePulse" />
          <p>Generating market structure review...</p>
        </div>
      )}

      {error && !analysis && (
        <div className="marketStructureError">
          <strong>Analysis unavailable</strong>
          <p>{error}</p>
        </div>
      )}

      {!isLoading && !error && !analysis && (
        <div className="marketStructureEmpty">
          <strong>No structure review yet</strong>
          <p>Waiting for the backend AI analysis.</p>
        </div>
      )}

      {analysis && (
        <div className="marketStructureContent">
          <TextBlock>{marketStructureReview}</TextBlock>
          <TextBlock>{currentStateInterpretation}</TextBlock>

          {traderTakeaway && (
            <div className="marketStructureTakeaway">
              <span>Trader Takeaway</span>
              <p>{traderTakeaway}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}